import {
  captureAndIdentify,
  identifyFromImage,
  isAvailable,
  checkCameraPermission,
  requestCameraPermission,
  CaptureAndIdentifyParams,
  IdentifyFromImageParams,
  CaptureAndIdentifyResponse,
  IdentifyFromImageResponse,
  IsAvailableResponse,
  CameraPermissionResponse,
} from "../../../modules/reactNativeBridge/FacialReactNativeBridge";

/**
 * Serviço de reconhecimento facial usando React Native Bridge
 * 
 * Este serviço fornece uma interface para interagir com o módulo nativo
 * de reconhecimento facial através do React Native Bridge.
 */
export class ReactNativeFacialService {
  /**
   * Captura uma imagem facial e identifica a pessoa automaticamente
   * @param params Parâmetros de captura e identificação
   * @returns Resultado da captura e identificação
   */
  async captureAndIdentify(
    params: CaptureAndIdentifyParams
  ): Promise<CaptureAndIdentifyResponse> {
    console.log("captureAndIdentify: params", params);
    const result = await captureAndIdentify(params);
    console.log("captureAndIdentify: result", result);
    return result;
  }

  /**
   * Identifica uma pessoa a partir de uma imagem já capturada (arquivo)
   * @param params Parâmetros de identificação a partir de arquivo
   * @returns Resultado da identificação
   */
  async identifyFromImage(
    params: IdentifyFromImageParams
  ): Promise<IdentifyFromImageResponse> {
    console.log("identifyFromImage: params", params);
    const result = await identifyFromImage(params);
    console.log("identifyFromImage: result", result);
    return result;
  }

  /**
   * Verifica se o módulo facial está disponível no dispositivo
   * @returns Resultado da verificação de disponibilidade
   */
  async isAvailable(): Promise<IsAvailableResponse> {
    return await isAvailable();
  }

  /**
   * Verifica se a permissão de câmera foi concedida
   * @returns Resultado da verificação de permissão
   */
  async checkCameraPermission(): Promise<CameraPermissionResponse> {
    return await checkCameraPermission();
  }

  /**
   * Solicita permissão de câmera ao usuário
   * @returns Resultado da solicitação de permissão
   */
  async requestCameraPermission(): Promise<CameraPermissionResponse> {
    return await requestCameraPermission();
  }
}

/**
 * Factory function para criar uma instância do serviço de reconhecimento facial
 * @returns Instância do ReactNativeFacialService
 */
export const ReactNativeFacial = (): ReactNativeFacialService => {
  return new ReactNativeFacialService();
};
